import { useSelector } from "react-redux";

// Custom hook to check for active session
export const useAuth = () => {
  const { hasActiveSession, sessionId } = useSelector((state) => state.auth);
  return hasActiveSession && sessionId;
};
